module.exports = __webpack_public_path__ + "static/media/empty-search-results.49327e66.png";